import React, { useContext, useState, useEffect } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { InfoBadge } from '@hz-design-system/web-ui';

import Classes from './FeatureBlock.module.scss';
import getStaticImageUrl from '../../utils/getStaticImageUrl';
import EnvironmentContext from '../../contexts/EnvironmentContext';

export const variants = {
  verifiedSeller: 'verified-seller',
  sellerPage: 'sellerpage',
  fotoknaller: 'fotoknaller',
  opvalsticker: 'opvalsticker',
  gallery: 'galerij',
};

const FeatureBlock = ({
  variant,
  title,
  body,
  isPlus = false,
}: {
  variant: string;
  title: string;
  body: string;
  isPlus?: boolean;
}) => {
  const i18n = useI18nContext();
  const { staticBaseUrl, tenant } = useContext(EnvironmentContext);
  const [imageUrl, setImageUrl] = useState<string>('');

  useEffect(() => {
    void Promise.resolve(import(`../../../images/bundle-page/${tenant}/${variant}.png`))
      .then((loadedImage) => loadedImage.default)
      .then((imagePath) => setImageUrl(getStaticImageUrl(staticBaseUrl, imagePath)));
  });

  return (
    <div className={Classes.root}>
      <div className={Classes.image} style={{ backgroundImage: `url(${imageUrl})` }} />
      <div className={Classes.contentSectionWrap}>
        <div>
          <div className={Classes.titleWrap}>
            <span className={Classes.title}>{title}</span>
            {isPlus && (
              <InfoBadge className={Classes.badge}>{i18n.t('purchaseBundle.featureOverview.badgePlus')}</InfoBadge>
            )}
          </div>
          <div className={Classes.body}>{body}</div>
        </div>
      </div>
    </div>
  );
};

export default FeatureBlock;
